import CartCTAs from './CartCTAs';

export default CartCTAs;
